import JsCookie from "js-cookie";

const getToken = JsCookie.get('ID_USER_ACCOUNT')

export const accessToken = getToken ? `Bearer ${getToken}` : false;